import { IBoardCasePerson } from './BoardCase'

export enum BoardActivityTypeEnum {
  Log = 'Log',
  Comment = 'Comment',
}

export enum BoardActivityStatusEnum {
  Meeting = 'Meeting',
  Case = 'Case',
}
export interface IBoardActivityFetchModel {
  id: string
  type: BoardActivityStatusEnum
}

export interface IBoardActivityUpdateModel {
  id: string
  type: BoardActivityStatusEnum
  commentId?: string
  text?: string
}

export enum BoardActivityActionEnum {
  Add = 'Add',
  Edit = 'Edit',
  Delete = 'Delete',
}

export interface IBoardActivity {
  id: string
  createdDate: Date
  createdBy: IBoardCasePerson

  editedDate?: Date
  editedBy?: IBoardCasePerson

  deletedDate?: Date
  deletedBy?: IBoardCasePerson
  commentText: string
  type: BoardActivityTypeEnum
  logActionEnum?: BoardActivityLogEnum
}

export interface IBoardActivityList extends IBoardActivity {
  result: IBoardActivity[]
}
export enum BoardActivityLogEnum {
  Created = 'Created',
  Edited = 'Edited',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Restored = 'Restored',
  CaseAdded = 'CaseAdded',
  CaseRemoved = 'CaseRemoved',
  AttachementAdded = 'AttachementAdded',
  AttachementRemoved = 'AttachementRemoved',
  NoticeSent = 'NoticeSent',
  MeetingResetToConductedNotCompletedByTechnicalSupportUser = 'MeetingResetToConductedNotCompletedByTechnicalSupportUser',
  MeetingResetToOngoingByTechnicalSupportUser = 'MeetingResetToOngoingByTechnicalSupportUser',
}

export enum BoardCommentsProcessingStateEnum {
  Addcomment = 'Addcomment',
  Editcomment = 'Editcomment',
  Deletecomment = 'Deletecomment',
}
